export enum WindowEnums {
  Provider = 1,
  Client = 2,
  Family = 3,
  Group = 4,
  Subgroup = 5,
  Article = 6,
  Store = 7,
  InventoryEntry = 9,
  InventoryOutput = 10,
  InventoryPeriod = 13,
  ProfileUser = 17,
  User = 18,
  Department = 20,
  City = 21,
  TypeInventory = 22,
  InventoryClass = 23,
  TypeConcept = 24,
  Transporter = 29,
  Seller = 30,
  Zone = 31,
  Vehicle = 32,
  ConstructionSite = 33,
  CostCenter = 34,
  PriceList = 35,
  CostCenterPrice = 36,
  RentalPeriod = 37,
  Remission = 38,
  Devolution = 39,
  SubrentalEntry = 43,
  SubrentalOutput = 44,
  TaxType = 45,
  Tax = 46,
  ConceptInvoicing = 47,
  InvoicingModel = 48,
  BussinessDocumentsType = 49,
  BussinessDocumentsResolution = 50,
  Invoice = 51,
  WayToPay = 52,
  IcaRate = 53,
  InvoicingCutoff = 54,
  Note = 55,
  AccountingInterface = 56,
  ElectronicInvoiceInterface = 57,
  Service = 68,
  Suspension = 69,
  BalancesImport = 70,
  ChargeAccount = 82,
  Order = 83,
  DocumentSupport = 81,
  InvoicesImport = 85,
  CashReceipt = 86,
  CashReceiptChargeAccount = 87,
  IncomeConcept = 88,
  WalletManagement = 100,
  NoteDocumentSupport = 101,
  CurrencyExchange = 107,
  TransferStoreWorkshop = 108,
  WorkshopEquipment = 109,
  ArticleGeneric = 110,
  MasterSolution = 111,
  TransferWorkshopStore = 112,
  Mechanic = 114,
  Sector = 118,
  Quotation = 119,
  Freight = 120,
  TransferConstructionSite = 126,
  MaintenanceOrder = 127,
  InternalOrder = 128,
  InventoryTransfer = 132,
  SalesRemission = 133,
  StorePrice = 134,
  ConsolidatedPendingsOrders = 135,
  SubrentalCutoff = 136,
  StockMaxMin = 140,
  InventoryReportStockMax = 147,
  InventoryReportStockMin = 148,
  PhysicalInventory = 151,
  InventoryReportTypeQuantities = 152,
  InventoryReportTypeSummaryValues = 153,
  RentalReportMovementsKilograms = 154,
  RentalReportCostCenterDiscounts = 155,
  MaintenanceActivities = 163,
  AdvanceInvoice = 170,
  MaintenanceRoutine = 175,
  ArticleTask = 184,
  MaintenanceReportEquipmentLogbook = 185,
  OrdersConsultation = 186,
  RequestNote = 188,
  AccountingModel = 189,
  ScheduledVisit = 198,
  ExecutedVisit = 199,
  TransportInvoice = 201,
  ProviderInvoice = 202,
}